import { render } from "./SeedJung_Review.vue?vue&type=template&id=be70c3f8&scoped=true"
import script from "./SeedJung_Review.vue?vue&type=script&lang=js"
export * from "./SeedJung_Review.vue?vue&type=script&lang=js"

import "./SeedJung_Review.vue?vue&type=style&index=0&id=be70c3f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be70c3f8"]])

export default __exports__